var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "content" };
var _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h2", { class: "text-xl font-semibold text-gray-700" }, "Registro Accessi"),
    /*#__PURE__*/ _createElementVNode("h3", null, "Impostazioni di sicurezza")
], -1);
var _hoisted_3 = { class: "flex justify-center my-4" };
var _hoisted_4 = ["disabled"];
var _hoisted_5 = { class: "px-4 py-2 text-gray-600" };
var _hoisted_6 = ["disabled"];
var _hoisted_7 = { class: "ml-2 mt-2 relative w-full overflow-x-auto shadow-md sm:rounded-lg" };
var _hoisted_8 = { class: "table-fixed w-full text-sm text-left text-gray-500 dark:text-gray-400" };
var _hoisted_9 = /*#__PURE__*/ _createElementVNode("thead", { class: "accessColor" }, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { scope: "col" }, "Data e Ora"),
        /*#__PURE__*/ _createElementVNode("th", { scope: "col" }, "Dispositivo"),
        /*#__PURE__*/ _createElementVNode("th", { scope: "col" }, "IP")
    ])
], -1);
var _hoisted_10 = { scope: "row" };
import { ref, onMounted, computed } from 'vue';
import { patientStore } from "@/store/patient";
var pageSize = 10;
export default /*#__PURE__*/ _defineComponent({
    __name: 'RegistroAccessi',
    setup: function (__props) {
        var _this = this;
        var store = patientStore();
        var loginLogs = ref([]);
        var currentPage = ref(1);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, store.fetchSecuritySettings()];
                    case 1:
                        _a.sent();
                        loginLogs.value = store.patient.loginLogs;
                        return [2 /*return*/];
                }
            });
        }); };
        var totalPages = computed(function () { return Math.ceil(loginLogs.value.length / pageSize); });
        var paginatedLogs = computed(function () {
            var startIndex = (currentPage.value - 1) * pageSize;
            var endIndex = startIndex + pageSize;
            return loginLogs.value.slice(startIndex, endIndex);
        });
        var prevPage = function () {
            currentPage.value--;
        };
        var nextPage = function () {
            currentPage.value++;
        };
        function formatDateTime(date, time) {
            return "".concat(date, " ").concat(time);
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                        onClick: prevPage,
                        disabled: currentPage.value === 1,
                        class: "px-4 py-2 bg-gray-200 text-gray-600 rounded-md cursor-pointer"
                    }, "Previous", 8, _hoisted_4),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(currentPage.value), 1),
                    _createElementVNode("button", {
                        onClick: nextPage,
                        disabled: currentPage.value === totalPages.value,
                        class: "px-4 py-2 bg-gray-200 text-gray-600 rounded-md cursor-pointer"
                    }, "Next", 8, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedLogs.value, function (log) {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: log.id_audit,
                                    class: "accessColor"
                                }, [
                                    _createElementVNode("td", _hoisted_10, _toDisplayString(formatDateTime(log.audit_data, log.audit_time)), 1),
                                    _createElementVNode("td", null, _toDisplayString(log.dispositivo), 1),
                                    _createElementVNode("td", null, _toDisplayString(log.audit_ip), 1)
                                ]));
                            }), 128))
                        ])
                    ])
                ])
            ]));
        };
    }
});
